import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Challenges = () => {
  const data = {
    labels: [
      'Geographic Isolation',
      'Shortage of medical and Dental Professionals',
      'Limited Financial Resources',
      'Lack of Oral Health Education',
      'Inadequate Infrastructure',
      'Workforce Retention Issues',
      'Policy & Funding Gaps'
    ],
    datasets: [{
      label: 'Severity of Challenge',
      data: [90, 85, 80, 75, 70, 65, 60],
      backgroundColor: 'rgba(20, 184, 166, 0.6)', // teal-500 with opacity
      borderColor: 'rgba(15, 118, 110, 1)', // teal-700
      borderWidth: 2,
      borderRadius: 4,
    }]
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: '#1f2937',
        titleFont: { size: 16 },
        bodyFont: { size: 14 },
        padding: 12,
        callbacks: {
          // label: function(context: any) {
          //   let label = context.dataset.label || '';
          //   return ' This is a major barrier to providing consistent care.';
          // }
        }
      }
    },
    scales: {
      x: {
        display: false,
        max: 100
      },
      y: {
        ticks: {
          font: {
            size: 14,
            family: "'Inter', sans-serif"
          },
          color: '#44403c' // stone-700
        },
        grid: {
          display: false
        }
      }
    }
  };

  return (
    <section id="challenges" className="bg-stone-100 py-20 md:py-28">
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-teal-700">The Landscape of Need</h2>
          <p className="mt-4 text-lg text-stone-600 max-w-3xl mx-auto">Our work is vital, but it's not easy. This chart shows the significant challenges we face in delivering oral healthcare across Sierra Leone. Your support helps us overcome these barriers.</p>
        </div>
        <div className="mt-12">
          <div className="chart-container" style={{ position: 'relative', height: '50vh', maxHeight: '500px', width: '100%', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
            <Bar options={options} data={data} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Challenges;